// @mui
import { Table, TableBody, TableContainer } from '@mui/material';
// components
import { TableHeadCustom } from 'src/components/table';
import TableRowCustom from 'src/components/table/TableRowCustom';

// ----------------------------------------------------------------------

interface Props {
  tableData: any[];
  tableConfig: any;
}

const SimpleTable: React.FC<Props> = ({ tableData, tableConfig }) => {
  return (
    <TableContainer sx={{ position: 'relative', py: 1 }}>
      <Table
        sx={{
          minWidth: 640,
          overflowX: 'scroll',
          '& .MuiTableCell-root': {
            p: '0 !important',
            background: 'none !important',
            borderBottom: 'none',
            whiteSpace: 'nowrap',
          },
        }}
      >
        <TableHeadCustom headLabel={tableConfig?.tableHead} />
        <TableBody
          sx={{
            '& .MuiTableRow-root:last-of-type > td, .MuiTableRow-root:first-of-type > td': {
              paddingTop: '12px !important',
            },
            '& .MuiTableRow-root:last-of-type > td': {
              fontWeight: 'bold !important',
              fontSize: '1rem !important',
            },
          }}
        >
          {tableData?.map(
            (row: any, index: number) =>
              row && <TableRowCustom key={index} rowConfig={tableConfig?.tableRow} row={row} />
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SimpleTable;
